module.exports = __webpack_public_path__ + "assets/img/time.5d406f14.svg";